import { cloneTr } from './clone-tr';
import { tableNodeTypes } from './table-node-types';

// Returns a new transaction that clears the content of a given `cell`.
export var emptyCell = function emptyCell(cell, schema) {
  return function (tr) {
    if (cell) {
      var node = tableNodeTypes(schema).cell.createAndFill();
      if (node && !cell.node.content.eq(node.content)) {
        tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
        return cloneTr(tr);
      }
    }
    return tr;
  };
};